const segments = [
    //akhbar
    [
        {
            "start": "0:00:02",
            "end": "0:00:13",
            "text": "رییس سازمان انرژی اتمی گفت اقدام بامداد امروز علیه مرکز غنی سازی نطنز نشان دهنده شکست مخالفان پیشرفت های صنعتی و سیاسی کشور"
        },
        {
            "start": "0:00:13",
            "end": "0:00:16",
            "text": "برای جلوگیری از توسعه چشمگیر صنعت هسته ای است"
        },
        {
            "start": "0:00:16",
            "end": "0:00:19",
            "text": "آقای صالحی افزود این اقدام همچنین"
        },
        {
            "start": "0:00:19",
            "end": "0:00:24",
            "text": "نشان دهنده ناکامی مخالفان مذاکرات ایران برای رفع تحریم های ظالمانه است"
        },
        {
            "start": "0:00:25",
            "end": "0:00:29",
            "text": "رییس سازمان انرژی اتمی ضمن محکوم کردن این حرکت [مذبوحانه]"
        },
        {
            "start": "0:00:29",
            "end": "0:00:37",
            "text": "[بر] ضرورت برخورد جامعه بین المللی و آژانس بین المللی انرژی اتمی با این تروریسم هسته ای تاکید کرد"
        },
        {
            "start": "0:00:37",
            "end": "0:00:39",
            "text": "آقای صالحی تصریح کرد ایران همچنین"
        },
        {
            "start": "0:00:39",
            "end": "0:00:45",
            "text": "حق خود را برای اقدام علیه عاملان آمران و مباشران محفوظ می داند"
        },
        {
            "start": "0:00:45",
            "end": "0:00:49",
            "text": "رییس سازمان انرژی اتمی تاکید کرد جمهوری اسلامی ایران همچنین"
        },
        {
            "start": "0:00:49",
            "end": "0:00:53",
            "text": "برای ناکام گذاشتن اهداف آمران این حرکت تروریستی"
        },
        {
            "start": "0:00:53",
            "end": "0:01:00",
            "text": "با جدیت گسترش فناوری هسته ای و تلاش برای رفع تحریم های ظالمانه را ادامه می دهد"
        }
    ],
    //podcast
    [
        {
            "start": "0:00:00",
            "end": "0:00:12",
            "text": "سلام و درود امروز جمعه سوم اردیبهشت هزار و [چهار صد] و اخبار این هفته زیست بوم اندیشکده [یک] کشور را [با] چهل و نهمین پادکست"
        },
        {
            "start": "0:00:12",
            "end": "0:00:14",
            "text": "خبری جامعه اندیشکده ها مرور می کنید"
        },
        {
            "start": "0:00:14",
            "end": "0:00:21",
            "text": "با موضوع انتخابات هزار و چهارصد شروع کنیم در آستانه انتخابات ریاست جمهوری پیش رو"
        },
        {
            "start": "0:00:21",
            "end": "0:00:32",
            "text": "جامعه اندیشکده ها با مشارکت اندیشکده های کشور طرحی در دست اجرا [دارید] با عنوان اندیشکده ها و نقش آفرینی در انتخابات هزار و چهارصد"
        },
        {
            "start": "0:00:32",
            "end": "0:00:39",
            "text": "این [ترتیب] سه مرحله [قرار] با شناسایی نظام مسایل کشور به سراغ نامزدهای انتخابات بره"
        },
        {
            "start": "0:00:39",
            "end": "0:00:51",
            "text": "به این صورت که ابتدا مسایل توسط اندیشکده ها و اندیشه ورزان شناسایی اولویت بندی و نهایی می [شوند] و در یک کمپین عمومی و با مشارکت شهروندان و رای [ده]"
        },
        {
            "start": "0:00:51",
            "end": "0:00:59",
            "text": "[یگان] درباره مسایل کشور و اولویت هایی که هر نامزد باید برای آنها برنامه ای داشته باشه نظر سنجی میشه"
        },
    ],
    //reading
    [
        {
            "start": "0:00:00",
            "end": "0:00:07",
            "text": "دست هایم حق زیادی به گردن من دارد"
        },
        {
            "start": "0:00:07",
            "end": "0:00:09",
            "text": "همراهی [کردند]"
        },
        {
            "start": "0:00:09",
            "end": "0:00:13",
            "text": "حتی در تمام لحظه هایی که با آنها نبودم"
        },
        {
            "start": "0:00:13",
            "end": "0:00:20",
            "text": "حتی روزهایی که کوبیدم شان به در و دیوار و زمین و آسمان آن هم به خاطر هیچ"
        },
        {
            "start": "0:00:20",
            "end": "0:00:25",
            "text": "دست هایم توانایی این را داشتند که در حساس ترین مسابقات والیبال"
        },
        {
            "start": "0:00:25",
            "end": "0:00:29",
            "text": "یا در نواختن حرفه ای یک ساز جهانی همراه [باشد]"
        },
        {
            "start": "0:00:29",
            "end": "0:00:36",
            "text": "می توانستم قلم مویی را استادانه در آغوش بگیرند و روی [بوم] سفید طرح هایی بزنند"
        },
        {
            "start": "0:00:36",
            "end": "0:00:38",
            "text": "فراتر از باور"
        },
        {
            "start": "0:00:38",
            "end": "0:00:41",
            "text": "اما حالا چه شده اند"
        },
        {
            "start": "0:00:41",
            "end": "0:00:44",
            "text": "کفش هایم را واکس می زند"
        },
        {
            "start": "0:00:44",
            "end": "0:00:48",
            "text": "آیا قراردادهای کاری ام را امضا می کند و گاهی"
        },
        {
            "start": "0:00:48",
            "end": "0:00:51",
            "text": "دیوان چای اسران [ام] را می شویند"
        },
        {
            "start": "0:00:51",
            "end": "0:00:54",
            "text": "[---]"
        },
        {
            "start": "0:00:54",
            "end": "0:01:06",
            "text": "حتی یادشان ندادم که گاهی مشتی دانه برای پرنده ها [باشد] در بهترین شرایط کیف چرمی کوچکی را برایم حمل می [کند] و دم نمی زن"
        },
        {
            "start": "0:01:06",
            "end": "0:01:07",
            "text": "در"
        },
        {
            "start": "0:01:07",
            "end": "0:01:19",
            "text": "دست هایم بین خط و خطوط شان [تبدیل] دیگری را برای خود می [گیرند] می خواستم قهرمان [شود] که مقابل چشم هزاران عاشق بالا می رو"
        },
        {
            "start": "0:01:19",
            "end": "0:01:31",
            "text": "شاد می شوند و دلشان می لرزد می خواستم هنرمند می [شوند و] یک شب بارانی را به تصویر بکشد"
        },
        {
            "start": "0:01:31",
            "end": "0:01:40",
            "text": "اما من ذوق این دست ها را کور [کرده]"
        }
    ],
    //historical
    [
        {
            "start": "0:00:00",
            "end": "0:00:04",
            "text": "و چگونه بجنگیم با [نجوم] در چنین اوضاع و احوالی"
        },
        {
            "start": "0:00:04",
            "end": "0:00:06",
            "text": "و بنی کلاب هم از سوی دیگر"
        },
        {
            "start": "0:00:06",
            "end": "0:00:09",
            "text": "قشیر و عقیل از ناحیه جداگانه"
        },
        {
            "start": "0:00:09",
            "end": "0:00:20",
            "text": "کافی است که بایستیم در برابر روم بهتر [این ها] را به نجور و [موساد بگید] و تمام قبایل عرب در دیار بکر و دیار بنی ربیعه"
        },
        {
            "start": "0:00:20",
            "end": "0:00:24",
            "text": "اطراف حرم [هست] بگید"
        },
        {
            "start": "0:00:24",
            "end": "0:00:27",
            "text": "به آنها [بد] کمک کنند سیف الدوله را"
        },
        {
            "start": "0:00:27",
            "end": "0:00:31",
            "text": "اجازه ندید از این نبرد صرف نظر کند"
        },
        {
            "start": "0:00:35",
            "end": "0:00:44",
            "text": "و هیچ کدام از سخنان شما گوش [نخواند] در اتاقی از اتاق های این قلعه"
        },
        {
            "start": "0:00:44",
            "end": "0:00:47",
            "text": "روباه مکار است"
        },
        {
            "start": "0:00:47",
            "end": "0:00:51",
            "text": "[که] مطمینم آماده جنگ [علیه]"
        },
        {
            "start": "0:00:51",
            "end": "0:01:03",
            "text": "هرگز اجازه نخواهیم داد ابدا تمام مقصود دسترسی به قدس"
        },
        {
            "start": "0:01:03",
            "end": "0:01:05",
            "text": "این رو زمانی آشکار کرد"
        },
        {
            "start": "0:01:05",
            "end": "0:01:09",
            "text": "که امیدش قطع شده بود و تصور می کرد مرگ [می]"
        }
    ],
    //majles
    [
        {
            "start": "0:00:00",
            "end": "0:00:10",
            "text": "همچنین از کلیه عزیزانی که در انتخابات گذشته این جانب را مورد لطف و محبت خود قرار دادند تقدیر و تشکر نموده"
        },
        {
            "start": "0:00:10",
            "end": "0:00:22",
            "text": "و از [این که] به دلیل [شیوع] بیماری کرونا امکان تقدیر و [تشکر] حضوری میسر نگردید عذرخواهی می [نماید] لازم می دانم از وزارت بهداشت و درمان علی الخصوص"
        },
        {
            "start": "0:00:22",
            "end": "0:00:29",
            "text": "پزشکان و پرستارانی که در مبارزه با بیماری کرونا شبانه روز در تلاش همت هستند تقدیر [چک] نمایم"
        },
        {
            "start": "0:00:29",
            "end": "0:00:39",
            "text": "و یاد و خاطره عزیزانی که در این مسیر شهد شیرین شهادت را نوشیدند گرامی بدارم در سالی که به فرموده مقام معظم رهبری"
        },
        {
            "start": "0:00:39",
            "end": "0:00:51",
            "text": "مزین به سال جهش تولید است پرتاب موفق ماهواره نور توسط سپاه پاسداران در شرایط تحریمی همراه با افتتاح پروژه های بزرگ صنعتی"
        },
        {
            "start": "0:00:51",
            "end": "0:00:51",
            "text": "[---]"
        },
        {
            "start": "0:00:51",
            "end": "0:00:58",
            "text": "از جمله کارخانه عظیم آلمینیوم جنوب بیمارستان جدید [یکصد] و بیست و چهار تخت خوابی [خیر] ساز لامر"
        },
        {
            "start": "0:00:58",
            "end": "0:01:01",
            "text": "با مساعدت خیر نیک اندیش"
        },
        {
            "start": "0:01:01",
            "end": "0:01:13",
            "text": "حاج محمود [حال] حیدر مجموعه بزرگ ورزشی شهید حاج قاسم سلیمانی و ترمینال جدید فرودگاه بین المللی [نامه] توسط ریاست محترم جمهور افتخارات"
        },
        {
            "start": "0:01:13",
            "end": "0:01:14",
            "text": "ارزشمندی بود"
        },
        {
            "start": "0:01:14",
            "end": "0:01:18",
            "text": "که امید را در دل ملت عزیز ایران زنده کرد"
        },
    ]
];

const segmentFixer = (falseSegments) => {
    let segments = [];
    for (let i = 0; i < falseSegments.length; i++) {
        let sample = [];
        for (let j = 0; j < falseSegments[i].length; j++) {
            let paragraph = {};
            paragraph.text = falseSegments[i][j].text
                .replaceAll("[","<span style='color: #7c7c7c;'>[")
                .replaceAll("]","]</span>");
            sample.push(paragraph);
            paragraph.start = falseSegments[i][j].start;
            paragraph.end = falseSegments[i][j].end;
        }
        segments.push(sample);
    }
    return segments;
};

export {segments,segmentFixer};
